import React from "react";
import Control from '../store/control';
import MarkingCommon from './markingCommon';

const ObjectAfo = () => {
  return (
    <>
      <MarkingCommon/>
    </>
  );
};

export default ObjectAfo;